import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ProblemStatement from '../components/ProblemStatement';
import Solutions from '../components/Solutions';
import Differentiators from '../components/Differentiators';
import UseCases from '../components/UseCases';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <ProblemStatement />
        <Solutions />
        <Differentiators />
        <UseCases />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;